import Vue from 'vue';
import Router from 'vue-router';
import Index from '../components/index.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      name: 'privacy_m',
      component: Index
    }
  ]
});



// WEBPACK FOOTER //
// ./src/module/privacy_m/router/index.js